import { SubscriptionPlanKey } from "@authory-packages/core";

export const getPlanLabel = (plan: SubscriptionPlanKey | null | undefined) => {
  switch (plan) {
    case SubscriptionPlanKey.USDMonthly:
      return "Monthly";
    case SubscriptionPlanKey.USDYearly:
      return "Yearly";
    case SubscriptionPlanKey.DiscountedUSDMonthly:
      return "Monthly - D";
    case SubscriptionPlanKey.DiscountedUSDYearly:
      return "Yearly - D";
    case SubscriptionPlanKey.USDMonthlyLegacy7:
      return "Monthly - L";
    case SubscriptionPlanKey.USDYearlyLegacy7:
      return "Yearly - L";
    case SubscriptionPlanKey.USDAuthoryProSub2023Yearly:
      return "2023 Pro Yearly";
    case SubscriptionPlanKey.USDAuthoryLiteMonthly:
      return "Lite Monthly";
    case SubscriptionPlanKey.USDAuthoryLiteYearly:
      return "Lite Yearly";
    case SubscriptionPlanKey.USDAuthoryProSub2023Monthly:
      return "2023 Pro Monthly";
    case SubscriptionPlanKey.USDAuthorySub2023Monthly:
      return "2023 Monthly";
    case SubscriptionPlanKey.USDAuthorySub2023Yearly:
      return "2023 Yearly";
    case SubscriptionPlanKey.USDAuthoryFreeProSub2023Monthly:
      return "Free Pro Monthly";
    case SubscriptionPlanKey.USDAuthoryFreeProSub2023Yearly:
      return "Free Pro Yearly";
    case SubscriptionPlanKey.USDAuthoryFreeSub2023Monthly:
      return "Free Monthly";
    case SubscriptionPlanKey.USDAuthoryFreeSub2023Yearly:
      return "Free Yearly";
    default:
      return "No Plan";
  }
};
